export default "__VITE_ASSET__a9c4214d__$_?component__"